import { highCourt } from "../assets/images";
import { emailIcon, phoneIcon, developerIcon } from "../assets/icons";

export const constants = {
    userRoles: {
        ADMIN: 'ADMIN' as const,
    }
}

export const contact = [
    {
        label: "kjoa@gmail.com",
        icon: emailIcon,
        iconName: "email",
        path: ""
    },
    {
        label: "0484-2714789",
        icon: phoneIcon,
        iconName: "phone",
        path:""
    },
    {
        label: "linkedin.com/in/ajukrishnaniitm",
        icon: developerIcon,
        iconName: "developer",
        path:"https://www.linkedin.com/in/ajukrishnaniitm/"
    }
]

export const usefullLinks = [
    {
        label: "Supreme Court of India",
        path: "https://en.wikipedia.org/wiki/Supreme_Court_of_India"
    },
    {
        label: "Kerala High Court",
        path: "https://en.wikipedia.org/wiki/Kerala_High_Court"
    },
    {
        label: "Kerala High Court website",
        path: "https://hckerala.gov.in/"
    },
    {
        label: "AIJA official website",
        path: "https://allindiajudges.org/"
    },
];


export const tagForGallery = [
    {
        key: 1,
        title: "Cricket 2023",
        pics: [
            {
                key: 1,
                pic: highCourt
            },
            {
                key: 2,
                pic: highCourt
            },
            {
                key: 3,
                pic: highCourt
            }],
    },
    {
        key: 2,
        title: "Sports Day 2023",
        pics: [
            {
                key: 1,
                pic: highCourt
            },
            {
                key: 2,
                pic: highCourt
            },
            {
                key: 3,
                pic: highCourt
            },
            {
                key: 4,
                pic: highCourt
            },
            {
                key: 5,
                pic: highCourt
            },
            {
                key: 6,
                pic: highCourt
            }
        ],
    },
    {
        key: 3,
        title: "Family Day 2023",
        pics: [
            {
                key: 1,
                pic: highCourt
            },
            {
                key: 2,
                pic: highCourt
            },
            {
                key: 3,
                pic: highCourt
            },
            {
                key: 4,
                pic: highCourt
            }
        ],
    }
];

export const tableData = [
    {
        jid: "1",
        name: "Rakesh MG",
        designation: "First Class Judicial Magistrtate",
        currentCourt: "Haripad First Class court",
        currentAddress: "Vrindavanam Mangalam Nagar Mangad PO Kollam",
        bloodGroup: "O+",
        about: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        pic: highCourt,
        age: 55,
        dob: "22-04-1999",
        phoneNumber: "1234567899",
        email: "test@mail.com"
    },
    {
        jid: "2",
        name: "Parvathy VC",
        designation: "First Class Judicial Magistrtate",
        currentCourt: "Kollam First Class court",
        currentAddress: "Vrindavanam Mangalam Nagar Mangad PO Kollam",
        bloodGroup: "AB-",
        about: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        pic: highCourt,
        age: 55,
        dob: "22-04-1999",
        phoneNumber: "1234567899",
        email: "test@mail.com"
    },

    {
        jid: "3",
        name: "Ajitha Kumary",
        designation: "Sub Judge",
        currentCourt: "Haripad First Class court",
        currentAddress: "Vrindavanam Mangalam Nagar Mangad PO Kollam",
        bloodGroup: "A-",
        about: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        pic: highCourt,
        age: 55,
        dob: "22-04-1999",
        phoneNumber: "1234567899",
        email: "test@mail.com"
    },
    {
        jid: "4",
        name: "Pranay PR",
        designation: "First Class Munsiff Magistrtate",
        currentAddress: "Vrindavanam Mangalam Nagar Mangad PO Kollam",
        currentCourt: "Haripad court",
        bloodGroup: "O+",
        about: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        pic: highCourt,
        age: 55,
        dob: "22-04-1999",
        phoneNumber: "1234567899",
        email: "test@mail.com"
    },
    {
        jid: "5",
        name: "Prakurthi PR",
        designation: "Sub Jugde",
        currentCourt: "Allapuzha court",
        currentAddress: "Vrindavanam Mangalam Nagar Mangad PO Kollam",
        bloodGroup: "B+",
        about: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        pic: highCourt,
        age: 55,
        dob: "22-04-1999",
        phoneNumber: "1234567899",
        email: "test@mail.com"
    },
    {
        jid: "6",
        name: "Ananthakrishnan U",
        designation: "High Court Judge",
        currentCourt: "High Court of Kerala",
        currentAddress: "Vrindavanam Mangalam Nagar Mangad PO Kollam",
        bloodGroup: "B-",
        about: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        pic: highCourt,
        age: 55,
        dob: "22-04-1999",
        phoneNumber: "1234567899",
        email: "test@mail.com"
    },
    {
        jid: "7",
        name: "Swetha Suresh",
        designation: "First Class Munsiff Magistrtate",
        currentAddress: "Vrindavanam Mangalam Nagar Mangad PO Kollam",
        currentCourt: "Kasargod court",
        bloodGroup: "O+",
        about: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        pic: highCourt,
        age: 55,
        dob: "22-04-1999",
        phoneNumber: "1234567899",
        email: "test@mail.com"
    },
    {
        jid: "8",
        name: "Ajukrishnan U",
        designation: "First Class Judicial Magistrtate",
        currentAddress: "Vrindavanam Mangalam Nagar Mangad PO Kollam",
        currentCourt: "Thrissur First Class  court",
        bloodGroup: "AB-",
        about: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        pic: highCourt,
        age: 55,
        dob: "22-04-1999",
        phoneNumber: "1234567899",
        email: "test@mail.com"
    },
    {
        jid: "9",
        name: "Reshma Rajeev",
        designation: "First Class Judicial Magistrtate",
        currentCourt: "Ernakulam First Class Judicial Court",
        currentAddress: "Vrindavanam Mangalam Nagar Mangad PO Kollam",
        bloodGroup: "AB-",
        about: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        pic: highCourt,
        age: 55,
        dob: "22-04-1999",
        phoneNumber: "1234567899",
        email: "test@mail.com"
    },
    {
        jid: "10",
        name: "Neeraja Rajeev",
        designation: "High Court Judge",
        currentCourt: "Hign Court Of Kerala",
        currentAddress: "Vrindavanam Mangalam Nagar Mangad PO Kollam",
        bloodGroup: "0+",
        about: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        pic: highCourt,
        age: 55,
        dob: "22-04-1999",
        phoneNumber: "1234567899",
        email: "test@mail.com"
    },
    {
        jid: "11",
        name: "Sanjay Nadh",
        designation: "High Court Judge",
        currentCourt: "Hign Court of Kerala",
        currentAddress: "Vrindavanam Mangalam Nagar Mangad PO Kollam",
        bloodGroup: "O-",
        about: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        pic: highCourt,
        age: 55,
        dob: "22-04-1999",
        phoneNumber: "1234567899",
        email: "test@mail.com"
    },


];

export const articleData = [
    {
        label: "Inheritance ans its use",
        path: "https://docs.google.com/presentation/d/16Xn0b2ziE9Yc579ObnoM8S76TixBvlqG/edit#slide=id.p1"
    },
    {
        label: "Inheritance ans its use",
        path: "https://docs.google.com/presentation/d/16Xn0b2ziE9Yc579ObnoM8S76TixBvlqG/edit#slide=id.p1"
    },
    {
        label: "Inheritance ans its use",
        path: "https://docs.google.com/presentation/d/16Xn0b2ziE9Yc579ObnoM8S76TixBvlqG/edit#slide=id.p1"
    },
    {
        label: "Inheritance ans its use",
        path: "https://docs.google.com/presentation/d/16Xn0b2ziE9Yc579ObnoM8S76TixBvlqG/edit#slide=id.p1"
    }
] 
